<template>
  <div class="host-sync-overlay">
    <div class="host-sync-card">
      <div class="host-sync-spinner" />
      <p class="host-sync-title">Starting Game...</p>
    </div>
  </div>
</template>

<style scoped>
.host-sync-overlay {
  position: absolute;
  inset: 0;
  z-index: 30;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 10, 18, 0.58);
  backdrop-filter: blur(2px);
}

.host-sync-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 20px 24px;
  border-radius: 12px;
  background: rgba(17, 24, 39, 0.92);
  border: 1px solid rgba(255, 255, 255, 0.18);
  text-align: center;
}

.host-sync-spinner {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.28);
  border-top-color: var(--color-primary);
  animation: host-spin 0.75s linear infinite;
}

.host-sync-title {
  margin: 0;
  color: var(--color-text-primary);
  font-size: 16px;
  font-weight: 700;
}

@keyframes host-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
